import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../users-module/services/user.service';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { ClientService } from '../../clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SearchPackage, SearchRecord, VendorResponseTypes, SearchVendors } from '../models/searchPackage';
import { SearchPackageService } from '../../services/search-package.service';
import { ValidationService } from '../../services/validation.service';
import * as _ from 'lodash';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-packages-add',
  templateUrl: './packages-add.component.html',
  styleUrls: ['./packages-add.component.css']
})
export class PackagesAddComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    try {

    } catch (error) {

    }
  }
  newPackage: SearchPackage = new SearchPackage();
  @ViewChild('form', {}) ngForm: NgForm;

  constructor(public packages : SearchPackageService, 
    public auth: AuthService,
    public users: UserService,
    public screening: ScreeningService,
    public clients: ClientService,
    public toast: ToastrService,
    public location: Router,
    public activatedRoute: ActivatedRoute,
    public validator: ValidationService) {
    if (!this.auth.UserInRole('CRA')) {
      this.location.navigateByUrl('/dashboard')
    }
    this.newPackage.isDefaultPackage = true;
    this.newPackage.clientId = this.auth.loggedInUser.clientId;
  }

  ngOnInit() {

  }

  savePackage() {
    if (this.ngForm.valid) {
      // this.newPackage.clientId = this.clientId;
      this.packages.SaveSearchPackage(this.newPackage).subscribe((ev: number) => {
        if (ev) {
          this.newPackage.id = ev;
          this.toast.success('Your search package was saved.', 'Package Save Successful');
          this.location.navigateByUrl(`/packages/edit/${this.newPackage.id}`);
        } else {
          this.toast.error('Your search package failed to save', 'Package Save Failture', { closeButton: true, disableTimeOut: true });
        }
      }, (err: any) => {
        this.toast.error('There was a problem saving your package. Please contact support if the issue persists.', 'Package Save Error', { disableTimeOut: true, closeButton: true })
      })
    }

  }
}
